export default __webpack_public_path__ + "static/media/landing-1.3b675055.png";